'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _colors = require('../settings/colors');

var _colors2 = _interopRequireDefault(_colors);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var IconUpload = function IconUpload(_ref) {
  var color = _ref.color,
      custom = _objectWithoutProperties(_ref, ['color']);

  return _react2.default.createElement(
    'svg',
    _extends({ fill: 'none', height: '24', viewBox: '0 0 24 24', width: '24' }, custom),
    _react2.default.createElement('path', { d: 'M4.84842884,18.7617067 L19.1515712,18.7617067 L19.1515712,15.6008934 C19.1515712,15.0925755 19.564695,14.676679 20.0757856,14.676679 C20.5868762,14.676679 21,15.0925755 21,15.6008934 L21,19.6859211 C21,20.1942391 20.5868762,20.6101356 20.0757856,20.6101356 L3.92421442,20.6101356 C3.41312384,20.6101356 3,20.1942391 3,19.6859211 L3,15.6008934 C3,15.0925755 3.41312384,14.676679 3.92421442,14.676679 C4.43438078,14.676679 4.84842884,15.0925755 4.84842884,15.6008934 L4.84842884,18.7617067 Z M11.2074562,3.36151838 C11.3373151,3.18994739 11.5529355,3.06357946 11.8074721,3.02061739 C11.9343221,2.99312754 12.0656779,2.99312754 12.1925279,3.02061739 C12.4471213,3.06358904 12.662781,3.19000376 12.7926307,3.36163317 L19.0434381,7.91219963 C19.4565619,8.20794824 19.5471349,8.79020333 19.2476895,9.19685767 C18.9473198,9.61275416 18.3669131,9.7051756 17.9565619,9.40018484 L12.9242144,5.7459744 L12.9242144,15.1797719 C12.9242144,15.583652 12.5110906,15.9140994 12,15.9140994 C11.4889094,15.9140994 11.0757856,15.583652 11.0757856,15.1797719 L11.0757856,5.7457662 L6.04158965,9.40018484 C5.87707948,9.52033272 5.68761553,9.58502773 5.49815157,9.58502773 C5.21256932,9.58502773 4.93068392,9.44639556 4.75046211,9.19685767 C4.44916821,8.79020333 4.54158965,8.20794824 4.95471349,7.91219963 L11.2074562,3.36151838 Z', fill: color }),
    ' '
  );
};

IconUpload.propTypes = {
  color: _propTypes2.default.string
};

IconUpload.defaultProps = {
  color: _colors2.default.icons
};

IconUpload.displayName = 'IconUpload';

exports.default = IconUpload;
module.exports = exports.default;